import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { ScarcityBar } from './ScarcityBar';
import { finalRecap, MOCKUP_IMAGE } from '../data/content';
export function FinalCta() {
  return <section className="bg-ink px-4 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-120" data-mp="15cubiodhgtka">
      <div className="mx-auto max-w-3xl text-center" data-id="element-121" data-mp="1jd51lp6yy44e">
        <h2 id="final-title" className="font-display text-4xl font-extrabold uppercase leading-[1.02] text-white sm:text-5xl" data-id="element-122" data-mp="1jbk6nygqsj60">
          Ready to stop guessing and <span className="text-amber" data-id="element-123" data-mp="1t1wsrv47gke9">start diagnosing with a clear plan?</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-mist" data-id="element-124" data-mp="1o4wif80bovhc">
          Your scanner gives you the fault code. The OBD2 Diagnostic Blueprint™ helps you understand what to
          investigate next.
        </p>

        <p className="mt-8 font-display text-xl font-bold uppercase text-white" data-id="element-125" data-mp="1x6cv5mem19oq">
          Imagine approaching your next Check Engine investigation with:
        </p>
        <ul className="mx-auto mt-4 max-w-lg space-y-2.5 text-left" data-id="element-126" data-mp="s5qobwnsb6u7">
          {finalRecap.map(item => <li key={item} className="flex items-start gap-3 text-[16px] text-white" data-id="element-127" data-mp="x2z821okzixk">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-128" data-mp="123521oibphit" />
              {item}
            </li>)}
        </ul>

        <img src={MOCKUP_IMAGE} alt="" aria-hidden="true" className="-mx-4 mt-10 w-[calc(100%+2rem)] max-w-none sm:mx-auto sm:w-full" data-id="element-129" data-mp="1b3jowsaxr4of" />

        <p className="mt-6 font-display text-2xl font-bold uppercase text-white" data-id="element-130" data-mp="1fvb98l3i0e64">
          6 Professional Volumes + 5 Exclusive Bonuses
        </p>
        <p className="mt-1 text-lg text-mist" data-id="element-131" data-mp="1kv7cgi4dg1km">
          <s data-id="element-132" data-mp="1pth80tu0d46r">$254</s> → <span className="font-display text-5xl font-extrabold text-amber" data-id="element-133" data-mp="1ptr3gwxto3ju">$27 USD</span>
        </p>
        <p className="mx-auto mt-3 flex max-w-sm items-center justify-center gap-2 text-sm font-semibold text-white" data-id="element-134" data-mp="1tuko9hfyx28i">
          <GlobeIcon className="h-4 w-4 shrink-0 text-ok" aria-hidden="true" data-id="element-135" data-mp="3qsktodp4nwp4" />
          Automatic conversion to your local currency
        </p>

        <div className="mx-auto mt-8 max-w-xl space-y-8" data-id="element-136" data-mp="3i4r0y4wvkve">
          <ScarcityBar data-id="element-137" data-mp="3jpkekfhoxro" />
          <CtaButton label="Yes! I want the Blueprint" sub="Instant Digital Access · One-Time Payment · Lifetime Access · 7-Day Guarantee" data-id="element-138" data-mp="3uwiucsu3pfka" />
          <CountdownTimer data-id="element-139" data-mp="dhvh8nmfvdpo" />
        </div>
      </div>
    </section>;
}